import { render, staticRenderFns } from "./Pindex.vue?vue&type=template&id=27c54edb&scoped=true&"
import script from "./Pindex.vue?vue&type=script&lang=js&"
export * from "./Pindex.vue?vue&type=script&lang=js&"
import style0 from "./Pindex.vue?vue&type=style&index=0&id=27c54edb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c54edb",
  null
  
)

export default component.exports